import React from 'react';
import { cn } from 'lib/utils';

export type FieldLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  className?: string;
  isRequired?: boolean;
  label: string;
  variant?: 'primary';
};

const FieldLabel = ({
  className,
  isRequired,
  label,
  variant = 'primary',
  ...props
}: FieldLabelProps) => {
  return (
    <label
      className={cn(
        'block font-sans',
        {
          // Variant: primary
          'text-clay-50 text-p4': variant === 'primary',
        },
        className
      )}
      {...props}
    >
      {label}
      {isRequired && <span>*</span>}
    </label>
  );
};

export default FieldLabel;
